<template>
  <div>
    <md-table v-model="globeActivity" class="globe-activity md-table-global-sales">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :class="getClass(item)">{{ item.action }}</md-table-cell>
        <!--<md-table-c>{{ item.role }}</md-table-c>-->
        <!--<md-table-cell>{{ item.actor }}</md-table-cell>ell   -->
        <md-table-cell style="font-family:Verdana, Geneva, Tahoma, sans-serif;">{{ item.member }}</md-table-cell>
        <md-table-cell >{{ item.globeID }}</md-table-cell>
        <md-table-cell :class="getClass(item)">{{ item.date }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import moment from "moment";
import axios from 'axios'

export default {
  name: "GlobeActivitySlimTable",
  data() {
    return {
      selected: [],
      globeActivity: [],
    };
  },
  computed: {
  },
  mounted: function () {
    this.getGlobeActivity()
  },
  methods: {
    getGlobeActivity: function () {
      const url = sessionStorage.getItem("API_SERVICE") + '/globe-activity/' + sessionStorage.getItem("username")
      const config = { headers: { 'Content-Type': 'application/json' } };
      const data = null;

      //console.log("getGlobeActivity:GET " + url);
      window.axios.get(url, data, config)
        .then(response => {
          //console.log(response);
          this.globeActivity = response.data;
          this.globeActivity.forEach(item => {
            item.date = moment(item.date, 'YYYY/MM/DDThh:mm:ss').format('dddd MMM Do   @h:mm a')
          });

        })
        .catch(errors => {
          console.log(errors);
          this.status = errors;
          //console.log(this.status);
        });
    },
    getClass(item) {
      if (item.action == "Screening") { return "isScreening" }
      if (item.action == "Report") { return "isReport" }

    },
  }
};
</script>

<style lang="scss" scoped>
.globe-activity {
  height: 45dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: .8rem;
  height: 35px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.isScreening {
  color: rgb(2, 171, 16);
  font-weight: 400;
  font-size: 0.87rem;
}

.isReport {
  color: rgb(32, 82, 191);
  font-weight: 400;
  font-size: 0.87rem;
}
</style>
